(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-card-rating]').forEach(badge => {
      let rating = Number(badge.dataset.cardNativeRating) || 0;
      let count = Number(badge.dataset.cardNativeCount) || 0;
      try {
        const source = JSON.parse(badge.dataset.cardReviewSource || '{}');
        const stats = source.bottomline;
        if (stats) { rating = Number(stats.averageScore) || 0; count = Number(stats.totalReviews) || 0; }
      } catch {}
      if (!Number.isFinite(rating) || !Number.isFinite(count) || count < 1 || rating < 0 || rating > 5) return;
      badge.querySelector('[data-card-stars-fill]').style.width = (rating / 5 * 100) + '%';
      badge.querySelector('[data-card-review-count]').textContent = '(' + count.toLocaleString() + ')';
      badge.setAttribute('aria-label', badge.dataset.ratingLabel.replace('__RATING__', rating.toFixed(1)).replace('__COUNT__', String(count)));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
